import React, { useEffect, useState } from "react";
import AdaptiveCard from "../components/AdaptiveCard";
import { getActiveRecallTopics } from "../helper/apicalls/activeRecall";
import GlobalLoader from "../components/GlobalLoader";
import "../styles/AdaptiveLearning.scss";
import notAvailable from "../assets/images/notAvalaible.svg";

const ActiveRecall = () => {
  const [activeTopics, setActiveTopics] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchTopics = async () => {
      try {
        if (isMounted) {
          setIsLoading(true);
        }

        const topics = await getActiveRecallTopics();
        if (isMounted) {
          setActiveTopics(topics);
        }
      } catch (error) {
        console.error("Error fetching active recall topics:", error);
        if (isMounted) {
          setActiveTopics([]);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchTopics();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="adaptive-learning">
      {isLoading && <GlobalLoader />}
      <div className="adaptive-learning-content custom-scrollbar">
        {activeTopics.length === 0 && !isLoading ? (
          <div className="not-found-container">
            <img
              src={notAvailable}
              alt="PowerPoint Icon"
              style={{ width: "300px", height: "300px", marginTop: "4px" }}
            />
            <h3>No Active recall Found!</h3>
          </div>
        ) : (
          <div className="adaptive-cards-container">
            {activeTopics.map((topic) => (
              <AdaptiveCard
                key={topic.id}
                title={topic.title}
                breadcrumb={topic.breadcrumb}
                status={topic.status}
                link={topic.link}
                cardType="active-recall"
                completed={topic.completed}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActiveRecall;
